import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { UseGetStatement } from "../../../core/services/api/get-statement";
import { countyNames } from "./MazandaranMap/counties";
import "./Announcement.scss";
import MazandaranMap from "./MazandaranMap/MazandaranMap";
import StatementCard from "../../Statements/StatementCard";
import OpenItemButton from "../../common/Buttons/OpenItemButton/OpenItemButton";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import { Link } from "react-router-dom";
import empty from "../../../assets/img/landing/icon/emptyFile.png";
import { RouteEnum } from "core/enum/route.enum";

const Announcement = () => {
  const [currentCounty, setCurrentCounty] = useState(0);

  const { data, isLoading, isError, isSuccess } = UseGetStatement();
  const statements = data?.data?.result?.statementList || [];
  const hasData = isSuccess && statements.length > 0;

  return (
    <section>
      <Container fluid className="announcements-container pr-lg-5 pt-lg-5">
        <Row>
          <Col xl={9}>
            <Row className="County-title">
              <Col lg={9}>
                <SectionTitle TitleText="شهرستان ها " />
              </Col>
            </Row>
            <Row className="County-detail-row">
              <Col className="County-news" xl={3}>
                <span className="County-title-news">
                  {countyNames[currentCounty] || "شهرستان‌ها"}
                </span>
                <p className="County-description">
                  {currentCounty === 0
                    ? "ماوس را روی هر شهرستان ببرید تا نام آن نمایش داده شود."
                    : "توضیحات این شهرستان به زودی اضافه می‌شود."}
                </p>
              </Col>
              <Col xl={9}>
                <MazandaranMap
                  currentCounty={currentCounty}
                  setCurrentCounty={setCurrentCounty}
                />
              </Col>
            </Row>
          </Col>
          <Col xl={3} className="statement-wrapper">
            <div className="statement-box">
              <SectionTitle TitleText="بیانیه و اطلاعیه" />

              <div className="statement-card pt-3">
                {isLoading && (
                  <div className="loading-state">
                    <p>لطفا منتظر بمانید...</p>
                    <div className="spinner" />
                  </div>
                )}

                {hasData && (
                  <>
                    {statements.map((news, index) => (
                      <div key={index} className="col-12 mb-2">
                        <Link
                          className="statement-link"
                          // to={{
                          //   pathname: `/Statement/Statements/${news.id}`,
                          //   state: { manifestData: news },
                          // }}
                          to={{
                            pathname: RouteEnum.StatementDetail.replace(
                              ":id",
                              String(news.id),
                            ),
                            state: { manifestData: news },
                          }}
                        >
                          <StatementCard statement={news} />
                        </Link>
                      </div>
                    ))}
                  </>
                )}

                {!hasData && (
                  <div className="empty-state">
                    <img alt="empty" src={empty} className="empty-image" />
                    <p className="empty-text">
                      بیانیه و اطلاعیه‌ای برای نمایش وجود ندارد
                    </p>
                  </div>
                )}

                {hasData && (
                  <Link to={RouteEnum.Statements}>
                    <OpenItemButton text="مشاهده بیشتر" />
                  </Link>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default Announcement;
